// tslint:disable
export var CallCenterStandardDaylightObserved;
(function (CallCenterStandardDaylightObserved) {
    // Observe Standard and Daylight Savings
    CallCenterStandardDaylightObserved[CallCenterStandardDaylightObserved["StandardDaylight"] = 1] = "StandardDaylight";
    // Observe Standard Time Only
    CallCenterStandardDaylightObserved[CallCenterStandardDaylightObserved["StandOnly"] = 2] = "StandOnly";
    // Observe Daylight Savings Time Only
    CallCenterStandardDaylightObserved[CallCenterStandardDaylightObserved["DaylightOnly"] = 3] = "DaylightOnly";
})(CallCenterStandardDaylightObserved || (CallCenterStandardDaylightObserved = {}));
CallCenterStandardDaylightObserved['STANDARDDAYLIGHT'] = 1;
CallCenterStandardDaylightObserved['STANDONLY'] = 2;
CallCenterStandardDaylightObserved['DAYLIGHTONLY'] = 3;
//# sourceMappingURL=CallCenterStandardDaylightObserved.js.map